import {useState} from 'react'
import {View} from 'react-native'
import {Trans, useLingui} from '@lingui/react/macro'

import {
  OnboardingControls,
  OnboardingDescriptionText,
  OnboardingPosition,
  OnboardingTitleText,
} from '#/screens/Onboarding/Layout'
import {useOnboardingInternalState} from '#/screens/Onboarding/state'
import {
  FAMILY_STAGE_ICONS,
  FAMILY_STAGES,
} from '#/screens/Onboarding/StepGoal/data'
import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import * as Toggle from '#/components/forms/Toggle'
import {Text} from '#/components/Typography'

export function StepFamilyStages() {
  const {t: l} = useLingui()
  const t = useTheme()
  const {state, dispatch} = useOnboardingInternalState()

  const [stages, setStages] = useState<string[]>(
    state.goalStepResults.familyStages,
  )

  function onContinue() {
    dispatch({type: 'setGoalResults', results: {familyStages: stages}})
    dispatch({type: 'next'})
  }

  return (
    <View style={[a.align_start, a.gap_sm]} testID="onboardingFamilyStages">
      <OnboardingPosition />
      <OnboardingTitleText>
        <Trans>Who's Learning at Home? 👨‍👩‍👧</Trans>
      </OnboardingTitleText>
      <OnboardingDescriptionText>
        <Trans>Select all the stages that apply to your children.</Trans>
      </OnboardingDescriptionText>

      <View style={[a.w_full, a.pt_lg]}>
        <Toggle.Group
          values={stages}
          onChange={setStages}
          label={l`Select your children's learning stages`}>
          <View style={[a.flex_row, a.flex_wrap, a.gap_sm]}>
            {FAMILY_STAGES.map(s => (
              <Toggle.Item key={s} name={s} label={s}>
                {({selected}) => (
                  <View
                    style={[
                      a.px_md,
                      a.py_sm,
                      a.rounded_full,
                      a.border,
                      selected
                        ? {
                            borderColor: 'transparent',
                            ...t.atoms.bg_contrast_975,
                          }
                        : t.atoms.border_contrast_low,
                    ]}>
                    <Text
                      style={[
                        a.text_sm,
                        a.font_bold,
                        selected && t.atoms.text_inverted,
                      ]}
                      emoji>
                      {FAMILY_STAGE_ICONS[s]} {s}
                    </Text>
                  </View>
                )}
              </Toggle.Item>
            ))}
          </View>
        </Toggle.Group>
      </View>

      <OnboardingControls.Portal>
        <Button
          disabled={stages.length === 0}
          testID="onboardingContinue"
          color="primary"
          size="large"
          label={l`Continue to next step`}
          onPress={onContinue}>
          <ButtonText>
            <Trans>Continue</Trans>
          </ButtonText>
        </Button>
      </OnboardingControls.Portal>
    </View>
  )
}
